var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    stroke: "white",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66732 2.66667H13.334C14.0673 2.66667 14.6673 3.26667 14.6673 4.00001V12C14.6673 12.7333 14.0673 13.3333 13.334 13.3333H2.66732C1.93398 13.3333 1.33398 12.7333 1.33398 12V4.00001C1.33398 3.26667 1.93398 2.66667 2.66732 2.66667Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 4L8.00065 8.66667L1.33398 4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.825d486968e75110c27eded8515c7cb5.svg";
export { ForwardRef as ReactComponent };